import React, { Component } from 'react';
import { graphql, withApollo, compose } from 'react-apollo';
import DashboardPage from './dashboard.js';
import Spinner from '../../spinner/spinner';
import { getCurrentUser } from '../../authorization/queries/getCurrentUser';
import { getChurchBasicInfo, getChurchesBasicInfo } from './queries/churches';
import { ROLES } from '../../authorization/roles';
import './dashboard.css';

class DashboardBuilder extends Component {
  constructor(props) {
    super(props);

    this.state = { churches: [], selectedChurch: null, user: null, dataLoaded: false };
  }

  componentWillReceiveProps(nextProps) {
    if(this.hasChurchChanged(nextProps)) {
      this.setState({ dataLoaded: false });
    }

    if(this.state.dataLoaded && !this.hasChurchChanged(nextProps)) {
      return;
    }

    const user = nextProps.data.current_user;
    const churchIdFromUrl = parseInt(nextProps.match.params.churchId, 10);

    if(this.isUrlInvalid(nextProps, churchIdFromUrl)) {
      return this.redirectToNoFound();
    }

    if(user) {
      switch(user.type) {
        case ROLES.admin:
          this.processAdmin(nextProps, user);
          break;
        case ROLES.evangelist:
          this.processEvangelist(churchIdFromUrl, user);
          break;
        case ROLES.seniorPastor:
        case ROLES.pastor:
          this.processPastor(churchIdFromUrl, user);
          break;
      }
    }
  }

  hasChurchChanged(nextProps) {
    return this.props.match.churchId !== nextProps.match.params.churchId;
  }

  isUrlInvalid(nextProps, churchIdFromUrl) {
    return nextProps.match.params.churchId && isNaN(churchIdFromUrl) && nextProps.match.params.churchId !== 'admin';
  }

  processPastor(churchIdFromUrl, user) {
    this.props.client.query({query: getChurchBasicInfo}).then(response => {
      const {church} = response.data.current_user;
      if (church.id !== churchIdFromUrl) {
        this.props.history.replace(`/dashboard/${church.id}`);
      } else {
        this.setState({churches: [church], selectedChurch: church, user: user, dataLoaded: true});
      }
    });
  }

  processEvangelist(churchIdFromUrl, user) {
    this.props.client.query({query: getChurchesBasicInfo}).then(response => {
      const churches = response.data.current_user.churches.edges.map(edge => edge.node);
      let church = null;
      if (churchIdFromUrl) {
        church = churches.find(church => church.id === churchIdFromUrl);
        this.setState({churches: churches, selectedChurch: church, user: user, dataLoaded: true});
      } else {
        church = churches.length > 0 ? churches[0] : null;
        this.props.history.replace(`/dashboard/${church ? church.id : null}`);
      }
    });
  }

  processAdmin(nextProps, user) {
    if (nextProps.match.params.churchId === 'admin') {
      this.setState({user: user, dataLoaded: true});
    } else {
      this.props.history.replace(`/dashboard/admin`);
    }
  }

  redirectToNoFound() {
    this.props.history.replace('/404');
  }

  render() {
    if(this.state.dataLoaded) {
      return <DashboardPage user={this.state.user} churches={this.state.churches}
                            selectedChurch={this.state.selectedChurch} />
    } else {
      return <Spinner />;
    }
  }
}

export default compose(
  withApollo,
  graphql(getCurrentUser)
)(DashboardBuilder);



// WEBPACK FOOTER //
// ./src/components/pages/dashboards/dashboardBuilder.js